import React from "react";

// Deterministic waveform built from song id so it looks stable per track.
const makeBars = (seed = "A001", count = 64) => {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  const bars = [];
  for (let i = 0; i < count; i++) {
    h = (h * 1664525 + 1013904223) >>> 0;
    const v = ((h % 100) / 100) * 0.85 + 0.15; // 0.15..1
    bars.push(v);
  }
  return bars;
};

export const Waveform = ({ seed, progress = 0, onSeek, count = 56 }) => {
  const bars = React.useMemo(() => makeBars(seed, count), [seed, count]);
  const ref = React.useRef(null);

  const handleClick = (e) => {
    if (!ref.current || !onSeek) return;
    const r = ref.current.getBoundingClientRect();
    const p = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
    onSeek(p);
  };

  return (
    <button
      ref={ref}
      type="button"
      onClick={handleClick}
      className="waveform cursor-pointer w-full"
      data-testid="waveform"
      aria-label="Seek track"
    >
      {bars.map((v, i) => {
        const active = i / bars.length <= progress;
        return (
          <span
            key={i}
            className="bar"
            style={{
              height: `${Math.round(v * 100)}%`,
              background: active ? "var(--gl-gold)" : "rgba(245,183,26,0.22)",
            }}
          />
        );
      })}
    </button>
  );
};

export default Waveform;
